const buildSettingsItemUrl = (workspaceId, sectionUid, id) => {
  if (!workspaceId || !sectionUid || !id) return null;
  return `/workspaces/${workspaceId}/settings/${sectionUid.toLowerCase()}/${id}`;
};

export default buildSettingsItemUrl;